import { BeforeRequestMiddleware } from '../types';

/**
 * Configure the request to allow passing credentials in cross-origin requests.
 *
 * This is necessary to allow services hosted on subdomains to pass the
 * appropriate cookies to the monolith in order to make authenticated requests.
 */
export const cors: BeforeRequestMiddleware = init => {
  // Note that we set credentials to `include` for every request as this
  // attribute has no incidence on same-origin requests.
  init.credentials = 'include';
  return init;
};
